(() => {
  'use strict';
  if (window.ShojikiJ001RevealCompositor) { window.ShojikiJ001RevealCompositor.initAll(); return; }

  function init(root) {
    if (root._shj1lrDestroy) return;
    const abort = new AbortController();
    const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal: abort.signal});
    const $ = id => root.querySelector(`[data-sjlr="${id}"]`);
    const stage = $('stage'), product = $('productWrap'), base = $('base-photo'), lights = $('lights');
    const lightImages = [...lights.querySelectorAll('img')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)'), narrow = matchMedia('(max-width: 749px)');
    const duration = Number(root.dataset.duration) || 9.2;
    const entry = Math.min(2 / duration, 1);
    // SH-J001: let the shadow lift over the whole movement, then show the copy.
    const milliseconds = Number(root.dataset.revealMs) || 2600;
    const clamp = v => Math.max(0, Math.min(1, v));
    const smooth = (a, b, p) => { const t = clamp((p - a) / (b - a)); return t * t * (3 - 2 * t); };
    const lerp = (a, b, t) => a + (b - a) * t;
    const offsets = Array.from({length: 97}, (_, i) => i / 96);
    let geometry, main = null, animations = [], destroyed = false, started = false, ready = false, lightingReady = false, lightingStarted = false, completed = false;
    const measure = () => ({mobile: narrow.matches, height: stage.getBoundingClientRect().height});
    function transform(p) {
      const settle = smooth(entry, 1, p);
      const top = geometry.mobile ? 53 : 59, height = geometry.mobile ? 116 : 140;
      const endTop = geometry.mobile ? 43 : 48, endHeight = geometry.mobile ? 86 : 110;
      return `translate3d(-50%, -50%, 0) translate3d(0, ${(endTop - top) * settle * geometry.height / 100}px, 0) scale(${lerp(height, endHeight, settle) / height})`;
    }
    function setGeometry(next) {
      geometry = next;
      product.style.top = (geometry.mobile ? 53 : 59) + '%';
      product.style.height = (geometry.mobile ? 116 : 140) + '%';
    }
    const keyframes = (property, value) => offsets.map(offset => ({offset, [property]: value(lerp(entry, 1, offset))}));
    function animate(el, property, value) {
      const animation = el.animate(keyframes(property, value), {duration: milliseconds, easing: 'linear', fill: 'both'});
      if (main) {
        // Late-decoded optional lights join the existing clock, without delaying the product.
        animation.currentTime = main.currentTime || 0;
        if (main.playState === 'paused') animation.pause();
        else if (main.startTime !== null) animation.startTime = main.startTime;
      }
      animations.push(animation);
      return animation;
    }
    function finish() {
      animations.forEach(animation => animation.cancel());
      animations = []; main = null; completed = true;
      product.style.transform = transform(1); product.style.willChange = 'auto';
      base.style.opacity = '1'; lights.style.opacity = '0';
      $('ambient').style.opacity = '.55'; $('horizon').style.opacity = '.075';
      $('ghost').style.opacity = geometry.mobile ? '.13' : '.10';
      stage.dataset.state = reduced.matches ? 'static' : 'complete';
      root.dataset.copy = 'visible';
    }
    function startLighting() {
      if (!lightingReady || lightingStarted || !main || completed || main.currentTime > milliseconds * .65) return;
      lightingStarted = true;
      lightImages.forEach(img => animate(img, 'opacity', p => {
        const x = lerp(620, 1105, smooth(entry, .96, p));
        const center = Number(img.dataset.lightX);
        const weight = clamp(1 - Math.abs(x - center) / 100);
        return weight * .72 * smooth(entry, entry + .12, p) * (1 - smooth(.77, 1, p));
      }));
      // Fade the decoded light group in once; this is also a native compositor animation.
      const fade = lights.animate([{opacity: 0}, {opacity: 1}], {duration: 160, fill: 'both'});
      if (document.hidden) fade.pause();
      animations.push(fade);
    }
    function maybeStart() {
      if (destroyed || started || !ready || document.hidden) return;
      if (document.documentElement.classList.contains('shj-veil-active') && !document.documentElement.classList.contains('shj-veil-done')) return;
      const rect = stage.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= innerHeight) return;
      started = true; veilObserver.disconnect(); intersection.disconnect();
      if (reduced.matches || typeof product.animate !== 'function' || milliseconds <= 0) { finish(); return; }
      stage.dataset.state = 'playing';
      main = animate(product, 'transform', transform);
      animate(base, 'opacity', p => lerp(.18, 1, Math.pow(smooth(entry, 1, p), 1.35)));
      animate($('ambient'), 'opacity', p => lerp(.025, .55, smooth(entry, 1, p)));
      animate($('horizon'), 'opacity', p => lerp(0, .075, smooth(entry, 1, p)));
      animate($('ghost'), 'opacity', p => lerp(0, geometry.mobile ? .13 : .10, smooth(.7, 1, p)));
      main.finished.then(() => { if (!destroyed && !completed) finish(); }).catch(() => {});
      startLighting();
    }
    const veilObserver = new MutationObserver(maybeStart);
    const intersection = new IntersectionObserver(maybeStart);
    veilObserver.observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
    intersection.observe(stage);
    setGeometry(measure());
    stage.dataset.state = 'pending';
    stage.dataset.durationMs = String(Math.round(milliseconds));
    // Reduced motion is complete immediately, including while the photo decodes.
    if (reduced.matches) {
      started = true; veilObserver.disconnect(); intersection.disconnect(); finish();
    }
    listen(window, 'resize', () => {
      const next = measure();
      if (next.mobile === geometry.mobile && next.height === geometry.height) return;
      setGeometry(next);
      if (completed) finish();
      else if (main) {
        main.effect.setKeyframes(keyframes('transform', transform));
        // The ghost has a slightly different final opacity on mobile.
        animations[4].effect.setKeyframes(keyframes('opacity', p => lerp(0, geometry.mobile ? .13 : .10, smooth(.7, 1, p))));
      }
    }, {passive: true});
    listen(document, 'visibilitychange', () => {
      animations.forEach(animation => {
        if (document.hidden && animation.playState === 'running') animation.pause();
        else if (!document.hidden && animation.playState === 'paused') animation.play();
      });
      maybeStart();
    });
    listen(reduced, 'change', () => { if (reduced.matches) { started = true; veilObserver.disconnect(); intersection.disconnect(); finish(); } });
    const decode = img => img.decode ? img.decode() : new Promise((resolve, reject) => {
      if (img.complete) { img.naturalWidth ? resolve() : reject(); return; }
      listen(img, 'load', resolve, {once: true}); listen(img, 'error', reject, {once: true});
    });
    decode(base).then(() => {
      if (destroyed) return;
      ready = true; root.dataset.ready = 'true'; maybeStart();
    }).catch(() => {
      if (destroyed) return;
      base.style.visibility = 'hidden';
      root.dataset.copy = 'visible';
      $('loadNote').style.display = 'block'; $('loadNote').textContent = '商品画像を読み込めませんでした。';
    });
    // Optional light assets never block the base image or movement.
    Promise.all(lightImages.map(decode)).then(() => { if (!destroyed) { lightingReady = true; startLighting(); } }).catch(() => {});
    root._shj1lrDestroy = () => {
      destroyed = true; abort.abort(); animations.forEach(animation => animation.cancel());
      veilObserver.disconnect(); intersection.disconnect(); delete root._shj1lrDestroy;
    };
  }
  function initAll(scope = document) { scope.querySelectorAll('[data-shj1lr-root]').forEach(init); }
  window.ShojikiJ001RevealCompositor = {initAll};
  initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-shj1lr-root]').forEach(root => root._shj1lrDestroy?.()));
})();
